var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / 24px / persons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon / 24px / persons_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7C9.5 8.10457 8.60457 9 7.5 9C6.39543 9 5.5 8.10457 5.5 7C5.5 5.89543 6.39543 5 7.5 5C8.60457 5 9.5 5.89543 9.5 7ZM11.5 7C11.5 9.20914 9.70914 11 7.5 11C5.29086 11 3.5 9.20914 3.5 7C3.5 4.79086 5.29086 3 7.5 3C9.70914 3 11.5 4.79086 11.5 7ZM7.5 14C9.91896 14 11.9367 15.7178 12.4 18H2.60002C3.06329 15.7178 5.08104 14 7.5 14ZM0.5 19C0.5 15.134 3.63401 12 7.5 12C10.111 12 12.3882 13.4295 13.5914 15.5487C14.6773 14.0071 16.471 13 18.5 13C21.8137 13 24.5 15.6863 24.5 19V19.125C24.5 19.6082 24.1082 20 23.625 20H13.5H13.375H1.5C0.947716 20 0.5 19.5523 0.5 19ZM22.374 18C21.9299 16.2748 20.3638 15 18.5 15C16.6362 15 15.0701 16.2748 14.626 18H22.374ZM19.5 9C19.5 9.55228 19.0523 10 18.5 10C17.9477 10 17.5 9.55228 17.5 9C17.5 8.44772 17.9477 8 18.5 8C19.0523 8 19.5 8.44772 19.5 9ZM21.5 9C21.5 10.6569 20.1569 12 18.5 12C16.8431 12 15.5 10.6569 15.5 9C15.5 7.34315 16.8431 6 18.5 6C20.1569 6 21.5 7.34315 21.5 9Z",
    fill: "#5E5F66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersons);
export default __webpack_public_path__ + "static/media/persons.af5c8c71224f33edae73c9ec7b2afbff.svg";
export { ForwardRef as ReactComponent };